export class AutoplayHelper {
    constructor(swiperRef, setIsAutoplayActive, isAutoplayActive, setIsLocked) {
        this.swiperRef = swiperRef;
        this.swiperRef.on('scroll', (swiper) => (swiper.wrapperEl.style.transitionDuration = this.swipeTiming));
        this.setIsAutoplayActive = setIsAutoplayActive;
        this.setIsLocked = setIsLocked;
        this.isAutoplayActive = isAutoplayActive;
    }
    setAutoplay(autoplay) {
        this.isAutoplayActive = autoplay;
        this.setIsAutoplayActive(autoplay);
    }
    realignPausedCarousel(originalTransform) {
        this.swiperRef.previousIndex--;
        this.swiperRef.realIndex--;
        this.swiperRef.activeIndex--;
        const originalTransformValues = originalTransform[1].split(/,\s?/g).map(parseInt);
        const originalDestTranslate = Math.floor(originalTransformValues[0]);
        const normalizedTranslate = Math.floor(Math.abs(originalDestTranslate));
        const normalizedSnapGrid = this.swiperRef.snapGrid.map((val) => Math.floor(Math.abs(val)));
        const originalDestIndex = normalizedSnapGrid.indexOf(normalizedTranslate);
        this.swiperRef.translate = -normalizedSnapGrid[originalDestIndex - 1];
    }
    pauseCarousel() {
        if (!this.swiperRef || !this.swiperRef.wrapperEl || !this.swiperRef.autoplay.running) {
            return;
        }
        this.swiperRef.autoplay.stop();
        this.swiperRef.animating = false;
        this.swiperRef.wrapperEl.style.transitionDuration = '0ms';
        const originalTransform = this.swiperRef.wrapperEl.style.transform.split(/\w+\(|\);?/);
        this.swiperRef.wrapperEl.style.transform = getComputedStyle(this.swiperRef.wrapperEl).transform;
        this.setAutoplay(false);
        setTimeout(() => {
            this.swiperRef.wrapperEl.style.transitionDuration = this.swipeTiming;
            this.swiperRef.wrapperEl.style.transform = `translate3d(${this.swiperRef.getTranslate()}px, 0, 0)`;
            const leftmostSlide = this.swiperRef.slides[this.swiperRef.previousIndex];
            const leftmostSlideBounds = leftmostSlide === null || leftmostSlide === void 0 ? void 0 : leftmostSlide.getBoundingClientRect();
            const leftmostHalfSlideVisible = (leftmostSlideBounds === null || leftmostSlideBounds === void 0 ? void 0 : leftmostSlideBounds.x) >= 0 || Math.abs(leftmostSlideBounds === null || leftmostSlideBounds === void 0 ? void 0 : leftmostSlideBounds.left) <= (leftmostSlideBounds === null || leftmostSlideBounds === void 0 ? void 0 : leftmostSlideBounds.width) / 2;
            if (leftmostHalfSlideVisible) {
                this.realignPausedCarousel(originalTransform);
            }
        }, 10);
    }
    playCarousel() {
        if (!this.swiperRef.autoplay.running) {
            this.swiperRef.autoplay.start();
            this.setAutoplay(true);
        }
    }
    handlePauseButton() {
        if (this.isAutoplayActive) {
            this.setIsLocked(true);
            this.pauseCarousel();
        }
        else {
            this.setIsLocked(false);
            this.playCarousel();
        }
    }
}
